import { PropsWithChildren } from "react";
import { Navigate, useParams } from "react-router-dom";

const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function WorkspaceIdGuard({ children }: PropsWithChildren) {
  const { workspaceId } = useParams();

  // Prevent routes like "/agents/billing" from being interpreted as a workspace route.
  if (!workspaceId || !UUID_V4_REGEX.test(workspaceId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
